export default __webpack_public_path__ + "static/media/logo-actguide-color.7218e020.png";